export type AuthMode = 'tenant' | 'platform';

export const AUTH_COOKIE_NAME = 'better-auth.session_token' as const;

export const AUTH_ERROR_CODES = {
  legacyPasswordResetRequired: 'LEGACY_PASSWORD_RESET_REQUIRED',
} as const;

const TENANT_AUTH_PREFIX = '/api/auth' as const;
const PLATFORM_AUTH_PREFIX = '/api/platform/auth' as const;

export const TENANT_AUTH_ENDPOINTS = {
  signUpEmail: `${TENANT_AUTH_PREFIX}/sign-up/email`,
  signInEmail: `${TENANT_AUTH_PREFIX}/sign-in/email`,
  signOut: `${TENANT_AUTH_PREFIX}/sign-out`,
  getSession: `${TENANT_AUTH_PREFIX}/get-session`,
} as const;

export const PLATFORM_AUTH_ENDPOINTS = {
  signInEmail: `${PLATFORM_AUTH_PREFIX}/sign-in/email`,
  signOut: `${PLATFORM_AUTH_PREFIX}/sign-out`,
  getSession: `${PLATFORM_AUTH_PREFIX}/get-session`,
} as const;

export const AUTH_ENDPOINTS = {
  tenant: TENANT_AUTH_ENDPOINTS,
  platform: PLATFORM_AUTH_ENDPOINTS,
} as const;

export const SESSION_ENDPOINTS = {
  tenant: TENANT_AUTH_ENDPOINTS.getSession,
  platform: PLATFORM_AUTH_ENDPOINTS.getSession,
} as const satisfies Record<AuthMode, string>;

export function buildAuthUrl(baseUrl: string | URL, endpoint: string): string {
  if (!endpoint.startsWith('/')) {
    throw new Error(`Auth endpoint paths must start with '/': received "${endpoint}"`);
  }

  const base = typeof baseUrl === 'string' ? baseUrl : baseUrl.toString();

  return new URL(endpoint, base).toString();
}
